import { useMemo } from 'react';

import { trpc } from '../trpc';
import { mutateSummaryData } from '../utils/breakdownData';

const SUMMARY_POLL_INTERVAL = 1000 * 60 * 60;

export function useSummaryQuery() {
  const { data, ...rest } = trpc.summary.get.useQuery(
    {},
    {
      refetchInterval: SUMMARY_POLL_INTERVAL,
    },
  );

  const mutatedData = useMemo(
    () => (data ? mutateSummaryData(data) : undefined),
    [data],
  );

  return {
    ...rest,
    data: mutatedData,
  };
}
